import getNodeLength from './getNodeLength';
export default function convertRetainToPoint(_ref, retain) {
  var value = _ref.value;
  var _value$selection$end = value.selection.end,
      key = _value$selection$end.key,
      offset = _value$selection$end.offset;
  var block = value.document.getClosestBlock(key); // Offset is the cursor offset in text node that contains the selection
  // We want the offset relative to the text node's parent block

  offset = offset + block.getOffset(key);

  while (block && retain >= 0) {
    var blockLength = getNodeLength(block);

    if (blockLength - offset > retain) {
      var textNode = block.getTextAtOffset(retain + offset);
      return {
        path: value.document.getPath(textNode.key),
        offset: retain + (offset - block.getOffset(textNode.key))
      };
    }

    retain = retain - (blockLength - offset);
    offset = 0;
    block = value.document.getNextBlock(block.key);
  }

  var lastBlock = value.document.getLastText();
  return {
    path: value.document.getPath(lastBlock.key),
    offset: getNodeLength(lastBlock),
    isLast: true
  };
}